module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue2.142fcf31ae315248ef75f7e5e1e52561.png";